import React, { useEffect } from "react";
// import preval from 'preval.macro'
// import { formatDateTH } from '../../../utilities/DateUtil'
import { APP_VERSION, APP_DEPLOY } from '../../../service/Config';


export default function FooterIndex() {

    return (
        <>
            {/* <div className="p-grid  p-fluid" style={{ marginTop: 5 }}>
                <div className="p-col-12 p-md-4 ">
                    <span> */}
            <b style={{ marginRight: 5 }}>Version: </b> {APP_VERSION} <b style={{ marginLeft: 10 ,marginRight: 5 }}>Update: </b> {APP_DEPLOY}
            {/* {formatDateTH(preval`module.exports = new Date();`,true)}. */}
            {/* </span>
                </div>
            </div> */}
        </>
    );
}
